// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"21636660","879":"774d20b1"}[chunkId] + ".chunk.js";
};